import axiosInstance from '../../api/axios';

const toNumber = (value: unknown) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export async function fetchControlsDashboardMetrics() {
  const response = await axiosInstance.get('/api/sox-controls/dashboard');
  const metrics = response?.data?.data ?? response?.data ?? {};

  return {
    total: toNumber(metrics?.total_count),
    riskUnmapped: toNumber(metrics?.risk_unmapped_count),
  };
}
